import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=0ffc94c8&scoped=true"
import script from "./RejectModal.vue?vue&type=script&lang=ts"
export * from "./RejectModal.vue?vue&type=script&lang=ts"
import style0 from "./RejectModal.vue?vue&type=style&index=0&id=0ffc94c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc94c8",
  null
  
)

export default component.exports